// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuickRepliesPopup_wrapper__1RCD5","controls":"QuickRepliesPopup_controls__3lTx2","content":"QuickRepliesPopup_content__FXs6r"};